import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  getCalendarState,
  MarketDrawerRootReducerState
} from '../../state/reducer';

@Component({
  selector: 'muni-gameday-market-drawer-body',
  templateUrl: './market-drawer-body.template.html',
  styleUrls: ['./market-drawer-body.styles.scss']
})
export class MarketDrawerBodyComponent {
  public readonly fullscreen: Observable<boolean> = this.store.pipe(
    map(state => getCalendarState(state).fullscreen)
  );

  constructor(private store: Store<MarketDrawerRootReducerState>) {}
}
